import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './LegalPage.css';

const LegalPage = () => {
    const location = useLocation();
    const isPrivacy = location.pathname.includes('privacy');
    const title = isPrivacy ? 'Politique de confidentialité' : "Conditions d'utilisation";

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = `${title} - Jeledi`;
    }, [title]);

    return (
        <div className="page legal-page">
            <div className="container">
                <h1>{title}</h1>
                <div className="legal-content">
                    <p className="last-updated">Dernière mise à jour : {new Date().toLocaleDateString()}</p>

                    {isPrivacy ? (
                        <>
                            <section>
                                <h2>1. Collecte des données</h2>
                                <p>Nous collectons uniquement les données nécessaires au bon fonctionnement de l'application, notamment votre voix et vos informations de profil basiques.</p>
                            </section>
                            <section>
                                <h2>2. Utilisation des données</h2>
                                <p>Vos données vocales sont utilisées pour permettre les échanges sur la plateforme. Nous ne vendons pas vos données à des tiers.</p>
                            </section>
                            <section>
                                <h2>3. Sécurité</h2>
                                <p>Nous mettons en œuvre des mesures de sécurité avancées pour protéger vos échanges et votre vie privée.</p>
                            </section>
                        </>
                    ) : (
                        <>
                            <section>
                                <h2>1. Acceptation des conditions</h2>
                                <p>En utilisant Jeledi, vous acceptez pleinement et sans réserve les présentes conditions d'utilisation.</p>
                            </section>
                            <section>
                                <h2>2. Comportement des utilisateurs</h2>
                                <p>Le respect et la bienveillance sont obligatoires. Tout contenu haineux, discriminatoire ou illégal est strictement interdit.</p>
                            </section>
                            <section>
                                <h2>3. Responsabilité</h2>
                                <p>Jeledi ne peut être tenu responsable des propos tenus par les utilisateurs, bien que nous modérions activement la plateforme.</p>
                            </section>
                        </>
                    )}

                    <section>
                        <h2>Contact</h2>
                        <p>Pour toute question juridique, contactez-nous à <a href="mailto:legal@jeledi.com">legal@jeledi.com</a>.</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default LegalPage;
